<template>
	<v-container :class='$vuetify.breakpoint.mdAndDown ? "pa-0" : "pa-0 px-1"' fluid>
		<v-row v-if='standalone_default_option' no-gutters style='width: 100%; margin-bottom: 10px'>
			<v-col
				:style='$vuetify.breakpoint.mdAndDown ? "padding: 2px" : "padding: 4px"'
				class='text-center'
				:cols='$vuetify.breakpoint.xsOnly ? 12 : 6'
				md='4'
			>
				<v-btn
					:depressed='isSelected(default_option)'
					:outlined='!isSelected(default_option)'
					block
					class='select_btn light-border br-3 modal-filter-all-button'
					color='primary'
					@click='optionClicked(default_option)'
				>
					{{ default_option.label }}
				</v-btn>

			</v-col>
			<v-col
				:style='$vuetify.breakpoint.mdAndDown ? "padding: 2px" : "padding: 4px"'
				class='d-flex justify-end text-right'
				cols='6'
				md='4'
				:v-if='hasSearchSlot'
			/>
			<v-col
				:style='$vuetify.breakpoint.mdAndDown ? "padding: 2px" : "padding: 4px"'
				class='d-flex justify-end text-right'
				cols='6'
				md='4'
				:v-if='hasSearchSlot'
			>
				<slot name='search' />
			</v-col>
		</v-row>

		<v-row align='center' align-content='center' no-gutters>
			<v-col
				v-for='option in options'
				:key='option.id'
				:cols='filter.two_lines_mobile ? 6 : 12'
				:style='$vuetify.breakpoint.mdAndDown ? "padding: 2px" : "padding: 4px"'
				class='text-center'
				md='4'
			>
				<v-btn
					:depressed='isSelected(option)'
					:outlined='!isSelected(option)'
					block
					:small='$vuetify.breakpoint.mdAndDown'
					class='select_btn light-border br-3 modal-filter'
					color='primary'
					@click='optionClicked(option)'
				>
					<div class='text-ellipsis' style='max-width: 100%'>
						{{ addUnitToLabel(filter, option.label) }}
					</div>
				</v-btn>
			</v-col>
		</v-row>

	</v-container>
</template>

<script>
	import BaseFilterMixin from './BaseFilterMixin'
	import utils from '../../libs/utils'
  import cloneDeep from 'lodash.clonedeep'

	export default {
		name: 'ConditionFilter',
		components: {},
		mixins: [BaseFilterMixin],

		data: () => {
			return {
				standalone_default_option: false,
				default_option: undefined,
				selected: [],
        savedFilters: []
			}
		},

		computed: {
      hasSearchSlot () {
        return !!this.$slots['search']
      },
			options() {
				let search = this.$store.dialogSearchText

				if (search) search = search.trim().toLowerCase()

				if (!this.standalone_default_option && !search) return this.filter.values

				const options = []
				for (let option of this.filter.values) {
					if (search) {
						if (!option.default && option.label.toLowerCase().includes(search)) options.push(option)
					} else if (!option.default) options.push(option) // remove default option from other options, if the default is standalone
				}

				return options
			}
		},

		watch: {
			selected: {
				deep: true,
				handler() {
					if (!this.selected.length) this.selected.push(this.default_option)
					this.updateFilter(this.selected)
				}
			}
		},

		mounted() {
			const default_option = this.filter.values.find(f => f.default);
			if (!default_option) {
			  console.warn('default option not specified for:', this.filter)
      }
			else if (this.filter.multiselect || (default_option.value < 1)) {
			  this.standalone_default_option = true
			}

			this.default_option = default_option

      this.selected = [this.default_option]

      if (this.filter.selectedValues && this.filter.selectedValues.length) {
        this.savedFilters = cloneDeep(this.filter.selectedValues)
        this.selected = this.filter.selectedValues
      }

      this.$bus.$on('abort:'+this.filter.name, (data) => {
        this.selected = [default_option]
      })
		},


		methods: {
		  isSelected(elem) {
		    return this.selected.filter(e => e.id == elem.id).length > 0
      },
			addUnitToLabel(filter, label) {
				return utils.addUnitToLabel(filter, label)
			},

			optionClicked(option) {
				const index = this.selected.findIndex(item => item.id === option.id );
				if (this.filter.multiselect) {
					const default_option_index = this.isSelected(this.default_option) ? 0 : -1
					// remove default option if an item is selected
					if ((option !== this.default_option) && (default_option_index !== -1)) {
						this.selected.splice(default_option_index, 1)
						this.selected.push(option)
					} else if (option === this.default_option) {
						// remove all items and add default option
						this.selected = [];
						this.selected.push(option)
					} else {
						if (index === -1)
						  this.selected.push(option)
						else
						  this.selected.splice(index, 1)
					}
				} else {
					if (index === -1) {
						this.selected.splice(0, 1)
						this.selected.push(option)
					} else this.selected.splice(0, 1)
				}
			}
		}
	}
</script>

<style>
	button.v-btn.select_btn, button.v-btn.select_btn .v-btn__content {
		font-size: 14px !important;
    font-weight: normal !important;
	}

	button.v-btn.select_btn .v-btn__content {
		width: 100%;
		max-width: 100%;
	}

	button.v-btn.select_btn {
		padding: 0 10px !important;
		max-width: 250px !important;
	}

	button.v-btn.select_btn.v-size--small {
		height: 32px !important;
	}
  .br-3 {
    border-radius: 3px !important;
  }
</style>
